import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';

// Layout & Components
import AdminLayout from './components/AdminLayout';
import AdminLogin from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import AdminDashboard from './pages/Dashboard';
import AdminBlogs from './pages/Blogs';
import AdminNews from './pages/News';
import AdminEnquiries from './pages/Enquiries';
import AdminFAQs from './pages/FAQs';
import AdminLogos from './pages/Logos';
import AdminSettings from './pages/Settings';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Public Login Route */}
          <Route path="/admin/login" element={<AdminLogin />} />
          
          {/* Protected Admin Routes */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="blogs" element={<AdminBlogs />} />
            <Route path="news" element={<AdminNews />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="faqs" element={<AdminFAQs />} />
            <Route path="logos" element={<AdminLogos />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* Root Redirect */}
          <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
